var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.memberHasLinkAccess ? _c('div', {
    staticClass: "sf-wrapper"
  }, [_c('div', {
    staticClass: "sf-container"
  }, [_vm._m(0), _c('div', {
    staticClass: "sf-right"
  }, [_vm._m(1), !_vm.successMessage ? _c('form', {
    staticClass: "sf-form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "sf-form-group"
  }, [_c('label', {
    staticClass: "sf-label"
  }, [_vm._v("Title "), _vm.form.doc_type !== 'ssn' ? _c('span', {
    staticClass: "input-required"
  }, [_vm._v("*")]) : _vm._e()]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.file_title,
      expression: "form.file_title",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "sf-input",
    attrs: {
      "type": "text",
      "placeholder": "Enter file title",
      "required": _vm.form.doc_type !== 'ssn'
    },
    domProps: {
      "value": _vm.form.file_title
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "file_title", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm.apiErrors.file_title ? _c('div', {
    staticClass: "error-message mt-1"
  }, [_vm._v(_vm._s(_vm.apiErrors.file_title[0]))]) : _vm._e()]), _c('div', {
    staticClass: "sf-form-group"
  }, [_vm._m(2), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.doc_type,
      expression: "form.doc_type"
    }],
    staticClass: "sf-select",
    attrs: {
      "required": ""
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.form, "doc_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select file type")]), _c('option', {
    attrs: {
      "value": "member_docs"
    }
  }, [_vm._v("Member Docs")]), _c('option', {
    attrs: {
      "value": "ssn"
    }
  }, [_vm._v("SSN")]), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other")])]), _vm.apiErrors.doc_type ? _c('div', {
    staticClass: "error-message mt-1"
  }, [_vm._v(_vm._s(_vm.apiErrors.doc_type[0]))]) : _vm._e()]), _vm.form.doc_type === 'ssn' ? _c('div', {
    staticClass: "sf-form-group"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.ssn,
      expression: "form.ssn",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "sf-input",
    attrs: {
      "type": "text",
      "placeholder": "Enter 9-digit SSN",
      "inputmode": "numeric",
      "pattern": "\\d{9}",
      "maxlength": "9"
    },
    domProps: {
      "value": _vm.form.ssn
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "ssn", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm.apiErrors.ssn ? _c('div', {
    staticClass: "error-message mt-1"
  }, [_vm._v(_vm._s(_vm.apiErrors.ssn[0]))]) : _vm._e()]) : _vm._e(), _vm.form.doc_type !== 'ssn' ? _c('div', {
    staticClass: "sf-form-group"
  }, [_vm._m(4), _c('div', {
    staticClass: "sf-dropzone",
    on: {
      "dragover": function ($event) {
        $event.preventDefault();
      },
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.onDrop.apply(null, arguments);
      },
      "click": _vm.triggerBrowse
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._m(5), _c('small', [_vm._v("Allowed: " + _vm._s(_vm.allowedFormats.join(', ')) + " (max 5MB per file)")]), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.onFileChange
    }
  })]), _vm._l(_vm.files, function (f, idx) {
    return _c('div', {
      key: f.uid,
      staticClass: "sf-file-item"
    }, [_c('div', {
      staticClass: "sf-file-info"
    }, [_c('strong', [_vm._v(_vm._s(f.file.name))]), _c('small', [_vm._v("(" + _vm._s(_vm.formatBytes(f.file.size)) + ")")])]), _c('button', {
      staticClass: "sf-remove-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function ($event) {
          return _vm.removeFile(idx);
        }
      }
    }, [_vm._v("Remove")])]);
  }), _vm.fileErrorString ? _c('div', {
    staticClass: "error-message mt-1"
  }, [_vm._v(_vm._s(_vm.fileErrorString))]) : _vm._e()], 2) : _vm._e(), _c('div', {
    staticClass: "sf-form-group"
  }, [_c('label', {
    staticClass: "sf-label"
  }, [_vm._v("Notes "), _vm.form.doc_type !== 'ssn' ? _c('span', {
    staticClass: "input-required"
  }, [_vm._v("*")]) : _vm._e()]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.doc_notes,
      expression: "form.doc_notes",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "sf-textarea",
    attrs: {
      "rows": "3",
      "placeholder": "Add notes",
      "required": _vm.form.doc_type !== 'ssn'
    },
    domProps: {
      "value": _vm.form.doc_notes
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "doc_notes", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm.apiErrors.doc_notes ? _c('div', {
    staticClass: "error-message mt-1"
  }, [_vm._v(_vm._s(_vm.apiErrors.doc_notes[0]))]) : _vm._e()]), _c('div', {
    staticClass: "sf-form-group"
  }, [_vm._m(6), _c('div', {
    staticClass: "sf-otp-container"
  }, _vm._l(_vm.otpDigits, function (digit, index) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: _vm.otpDigits[index],
        expression: "otpDigits[index]",
        modifiers: {
          "number": true
        }
      }],
      key: index,
      ref: "otpInputs",
      refInFor: true,
      staticClass: "form-control otp-input",
      attrs: {
        "maxlength": "1",
        "min": "0",
        "max": "9"
      },
      domProps: {
        "value": _vm.otpDigits[index]
      },
      on: {
        "input": [function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.otpDigits, index, _vm._n($event.target.value));
        }, function ($event) {
          return _vm.handleOtpInput(index, $event);
        }],
        "keydown": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) return null;
          return _vm.handleOtpDelete(index, $event);
        }, function ($event) {
          return _vm.preventNonNumeric($event);
        }],
        "paste": function ($event) {
          return _vm.handlePaste($event);
        },
        "blur": function ($event) {
          return _vm.$forceUpdate();
        }
      }
    });
  }), 0), _vm.apiErrors.otp ? _c('div', {
    staticClass: "error-message mt-1"
  }, [_vm._v(_vm._s(_vm.apiErrors.otp[0]))]) : _vm._e()]), _c('div', {
    staticClass: "sf-submit-container"
  }, [_c('button', {
    staticClass: "sf-upload-btn",
    attrs: {
      "type": "submit",
      "disabled": _vm.uploading || _vm.isFormIncomplete
    }
  }, [_vm.uploading ? _c('span', {
    staticClass: "sf-spinner"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.uploading ? 'Submitting...' : 'Submit') + " ")])])]) : _vm._e()])])]) : _vm._e();

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sf-left"
  }, [_c('div', {
    staticClass: "sf-illustration"
  }, [_c('img', {
    staticClass: "sf-hero-img",
    attrs: {
      "src": require("../../assets/images/file-upload-illustration.png"),
      "alt": "Core Enroll Logo"
    }
  })]), _c('h2', {
    staticClass: "sf-title"
  }, [_vm._v("Secure File Portal")]), _c('p', {
    staticClass: "sf-subtitle"
  }, [_vm._v("Upload your documents safely and verify with OTP.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sf-header"
  }, [_c('img', {
    staticClass: "sf-logo",
    attrs: {
      "src": require("../../assets/corenroll-logo-dark.png"),
      "alt": "Core Enroll Logo"
    }
  }), _c('h4', {
    staticClass: "sf-heading"
  }, [_vm._v("Secure File Upload")]), _c('p', {
    staticClass: "sf-desc"
  }, [_vm._v("Please upload your document securely. Enter OTP sent to your email.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "sf-label"
  }, [_vm._v("Category "), _c('span', {
    staticClass: "input-required"
  }, [_vm._v("*")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "sf-label"
  }, [_vm._v("Social Security Number "), _c('span', {
    staticClass: "input-required"
  }, [_vm._v("*")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "sf-label"
  }, [_vm._v("Select File "), _c('span', {
    staticClass: "input-required"
  }, [_vm._v("*")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_vm._v("Drag & drop files here or "), _c('span', {
    staticClass: "sf-browse"
  }, [_vm._v("browse")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "sf-label"
  }, [_vm._v("Enter OTP "), _c('span', [_vm._v("*")])]);

}]

export { render, staticRenderFns }